// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents';
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives';
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from './components/SidebarPlugin';
// Tabs plugin. Used on Panels page.

// import VueMaterial from 'vue-material';

import {
    MdApp,
    MdBadge,
    MdAutocomplete,
    MdAvatar,
    MdBottomBar,
    MdButton,
    MdCard,
    MdCheckbox,
    MdChips,
    MdContent,
    MdDatepicker,
    MdDialog,
    MdDialogAlert,
    MdDialogConfirm,
    MdDialogPrompt,
    MdDivider,
    MdDrawer,
    MdElevation,
    MdEmptyState,
    MdField,
    MdHighlightText,
    MdIcon,
    MdImage,
    MdLayout,
    MdList,
    MdMenu,
    MdProgress,
    MdRadio,
    MdRipple,
    MdSnackbar,
    MdSpeedDial,
    MdSteppers,
    MdSubheader,
    MdSwitch,
    MdTable,
    MdToolbar,
    MdTooltip,
} from 'vue-material/dist/components';

// asset imports
import 'vue-material/dist/vue-material.min.css';
import './assets/scss/material-dashboard.scss';
import './assets/css/demo.css';

// library auto imports
import 'es6-promise/auto';

export default {
    install(Vue) {
        Vue.use(GlobalComponents);
        Vue.use(GlobalDirectives);
        // Vue.use(VueMaterial);
        Vue.use(MdApp);
        Vue.use(MdBadge);
        Vue.use(MdAutocomplete);
        Vue.use(MdAvatar);
        Vue.use(MdBottomBar);
        Vue.use(MdButton);
        Vue.use(MdCard);
        Vue.use(MdCheckbox);
        Vue.use(MdChips);
        Vue.use(MdContent);
        Vue.use(MdDatepicker);
        Vue.use(MdDialog);
        Vue.use(MdDialogAlert);
        Vue.use(MdDialogConfirm);
        Vue.use(MdDialogPrompt);
        Vue.use(MdDivider);
        Vue.use(MdDrawer);
        Vue.use(MdElevation);
        Vue.use(MdEmptyState);
        Vue.use(MdField);
        Vue.use(MdHighlightText);
        Vue.use(MdIcon);
        Vue.use(MdImage);
        Vue.use(MdLayout);
        Vue.use(MdList);
        Vue.use(MdMenu);
        Vue.use(MdProgress);
        Vue.use(MdRadio);
        Vue.use(MdRipple);
        Vue.use(MdSnackbar);
        Vue.use(MdSpeedDial);
        Vue.use(MdSteppers);
        Vue.use(MdSubheader);
        Vue.use(MdSwitch);
        Vue.use(MdTable);
        Vue.use(MdToolbar);
        Vue.use(MdTooltip);
        Vue.use(SideBar);
    },
};
